module.exports = __webpack_public_path__ + "img/212.855e2cf6.jpg";